module.exports = __webpack_public_path__ + "media/common/statics/lesson_icon/3-59f082988429277986810195bca34925.png";